import { z } from "zod"

import { INSTITUTION_KINDS } from "@/constants/institutions"

// The academic-config trio (PRD-38) is NOT part of this schema: it is owned by
// `useAcademicConfig` + `<AcademicConfigFields>` (see @lib/academicConfig), so
// the type→count prefill can live in a change handler instead of an effect.
// The form merges the two halves at submit time.
// One shape for create and edit. `kind` starts empty so the superuser picks
// it: the two create paths used to default to different values.
export const institutionSchema = z.object({
  name: z.string().trim().min(1, "required").max(200, "too_long"),
  kind: z.enum(INSTITUTION_KINDS, { errorMap: () => ({ message: "required" }) }),
})

export type InstitutionInput = z.infer<typeof institutionSchema>
